import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { useCreateBrandVisualAnalysis } from 'hooks/queries/brandVisualAnalyses/useCreateBrandVisualAnalysis'
import { BrandVisualAnalysis } from 'types'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { reportError } from 'utils/error'
import { ButtonProps } from 'blaze-ui/Button/Types'

interface Props extends Pick<ButtonProps, 'frontIcon' | 'variant' | 'fullWidth' | 'isDisabled'> {
  integration: ExternalIntegration
  onGenerate: (analysis: BrandVisualAnalysis) => void
}

export const GenerateAgainButton = ({ integration, onGenerate, frontIcon, variant, fullWidth, isDisabled }: Props) => {
  const { mutateAsync, isLoading } = useCreateBrandVisualAnalysis()

  const handlePress = async () => {
    try {
      const analysis = await mutateAsync({ external_integration_id: integration.id })
      onGenerate(analysis)
    } catch (e) {
      reportError(e)
      showErrorMessageToast('An error occurred')
    }
  }

  return (
    <Button
      size="lg"
      variant={variant}
      frontIcon={frontIcon}
      onPress={handlePress}
      isDisabled={isLoading || isDisabled}
      fullWidth={fullWidth}
    >
      Generate Again
    </Button>
  )
}
